const getNameForItem = (item) => (item.name !== '' ? `${item.name}` : 'Untitled');

export default getNameForItem;
